
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/link/measuring-conversion",
      function () {
        return require("private-next-pages/docs/link/measuring-conversion.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/link/measuring-conversion"])
      });
    }
  